import { Translate } from '@chipinside/translate'
import { Box, CircularProgress, CircularProgressProps, styled, SxProps, Theme } from '@mui/material'
import { Typography } from '@mui/material'
import React from 'react'

const Wrapper = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
})

type CircularLoaderProps = {
  minHeight?: number
  color?: CircularProgressProps['color']
  containerStyle?: React.CSSProperties
  sx?: SxProps<Theme>
}

const CircularLoader = ({ color, containerStyle = {}, minHeight, sx }: CircularLoaderProps) => {
  return (
    <Wrapper style={{ minHeight, ...containerStyle }} sx={sx}>
      <CircularProgress color={color} />
      <Typography color="secondary" sx={{ mt: 3 }}>
        {Translate({ messageKey: 'loading_just_a_moment' })}
      </Typography>
    </Wrapper>
  )
}

export { CircularLoader }
